module.exports = __webpack_public_path__ + "static/media/payment-tick-monthly.17735df7.svg";